// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1AbTW","allMatchedText":"styles_allMatchedText__37-SH","reviewButton":"styles_reviewButton__1bkSh"};